__turbopack_context__.v({
  "buyLink": "Ho9lYW_buyLink",
  "buyList": "Ho9lYW_buyList",
  "buyPartnerLink": "Ho9lYW_buyPartnerLink",
  "buyPartnerLogo": "Ho9lYW_buyPartnerLogo",
  "buyPartnerName": "Ho9lYW_buyPartnerName",
  "buyPartnersGrid": "Ho9lYW_buyPartnersGrid",
  "contentCard": "Ho9lYW_contentCard",
  "contentPageTitle": "Ho9lYW_contentPageTitle",
  "contentSubtitle": "Ho9lYW_contentSubtitle",
  "factionLabel": "Ho9lYW_factionLabel",
  "factionLink": "Ho9lYW_factionLink",
  "factionLinkActive": "Ho9lYW_factionLinkActive",
  "factionLinks": "Ho9lYW_factionLinks",
  "factionRow": "Ho9lYW_factionRow",
  "filterTab": "Ho9lYW_filterTab",
  "filterTabActive": "Ho9lYW_filterTabActive",
  "filterTabs": "Ho9lYW_filterTabs",
  "hero": "Ho9lYW_hero",
  "heroContent": "Ho9lYW_heroContent",
  "heroCta": "Ho9lYW_heroCta",
  "heroSubtitle": "Ho9lYW_heroSubtitle",
  "heroTitle": "Ho9lYW_heroTitle",
  "main": "Ho9lYW_main",
  "page": "Ho9lYW_page",
  "productAboutText": "Ho9lYW_productAboutText",
  "productBody": "Ho9lYW_productBody",
  "productCard": "Ho9lYW_productCard",
  "productCta": "Ho9lYW_productCta",
  "productDescriptionHeading": "Ho9lYW_productDescriptionHeading",
  "productDetailBody": "Ho9lYW_productDetailBody",
  "productDetailCard": "Ho9lYW_productDetailCard",
  "productDetailCta": "Ho9lYW_productDetailCta",
  "productDetailGrid": "Ho9lYW_productDetailGrid",
  "productDetailInfo": "Ho9lYW_productDetailInfo",
  "productDetailSection": "Ho9lYW_productDetailSection",
  "productDetailSpec": "Ho9lYW_productDetailSpec",
  "productDetailTags": "Ho9lYW_productDetailTags",
  "productDetailTitle": "Ho9lYW_productDetailTitle",
  "productDetailWrap": "Ho9lYW_productDetailWrap",
  "productFeatureIcon": "Ho9lYW_productFeatureIcon",
  "productFeatureLabel": "Ho9lYW_productFeatureLabel",
  "productFeatureStat": "Ho9lYW_productFeatureStat",
  "productFeatureText": "Ho9lYW_productFeatureText",
  "productFeatureValue": "Ho9lYW_productFeatureValue",
  "productFeaturesBlock": "Ho9lYW_productFeaturesBlock",
  "productFeaturesList": "Ho9lYW_productFeaturesList",
  "productFeaturesStats": "Ho9lYW_productFeaturesStats",
  "productFeaturesTitle": "Ho9lYW_productFeaturesTitle",
  "productImage": "Ho9lYW_productImage",
  "productImageImg": "Ho9lYW_productImageImg",
  "productImageLink": "Ho9lYW_productImageLink",
  "productRichContent": "Ho9lYW_productRichContent",
  "productSectionTitle": "Ho9lYW_productSectionTitle",
  "productSpec": "Ho9lYW_productSpec",
  "productSpecRow": "Ho9lYW_productSpecRow",
  "productTag": "Ho9lYW_productTag",
  "productTagFaction": "Ho9lYW_productTagFaction",
  "productTagSubcategory": "Ho9lYW_productTagSubcategory",
  "productTags": "Ho9lYW_productTags",
  "productTitle": "Ho9lYW_productTitle",
  "productTitleLink": "Ho9lYW_productTitleLink",
  "productsFilters": "Ho9lYW_productsFilters",
  "productsGrid": "Ho9lYW_productsGrid",
  "section": "Ho9lYW_section",
  "sectionBestsellers": "Ho9lYW_sectionBestsellers",
  "sectionCta": "Ho9lYW_sectionCta",
  "sectionHeader": "Ho9lYW_sectionHeader",
  "sectionInner": "Ho9lYW_sectionInner",
  "sectionLink": "Ho9lYW_sectionLink",
  "sectionProductDetail": "Ho9lYW_sectionProductDetail",
  "sectionSubtitle": "Ho9lYW_sectionSubtitle",
  "sectionTitle": "Ho9lYW_sectionTitle",
  "sectionWhy": "Ho9lYW_sectionWhy",
  "topOfferBadge": "Ho9lYW_topOfferBadge",
  "topOfferCoupon": "Ho9lYW_topOfferCoupon",
  "topOfferCta": "Ho9lYW_topOfferCta",
  "topOfferLogo": "Ho9lYW_topOfferLogo",
  "topOfferLogoWrap": "Ho9lYW_topOfferLogoWrap",
  "topOfferPrice": "Ho9lYW_topOfferPrice",
  "topOfferPriceBlock": "Ho9lYW_topOfferPriceBlock",
  "topOfferPriceUnknown": "Ho9lYW_topOfferPriceUnknown",
  "topOfferRank": "Ho9lYW_topOfferRank",
  "topOfferRow": "Ho9lYW_topOfferRow",
  "topOfferRowBest": "Ho9lYW_topOfferRowBest",
  "topOfferShipping": "Ho9lYW_topOfferShipping",
  "topOfferStore": "Ho9lYW_topOfferStore",
  "topOfferStoreMeta": "Ho9lYW_topOfferStoreMeta",
  "topOfferStoreName": "Ho9lYW_topOfferStoreName",
  "topOffers": "Ho9lYW_topOffers",
  "topOffersHeader": "Ho9lYW_topOffersHeader",
  "topOffersList": "Ho9lYW_topOffersList",
  "topOffersNote": "Ho9lYW_topOffersNote",
  "topOffersSubtitle": "Ho9lYW_topOffersSubtitle",
  "topOffersTitle": "Ho9lYW_topOffersTitle",
  "whyBlock": "Ho9lYW_whyBlock",
  "whyChecklist": "Ho9lYW_whyChecklist",
  "whyDesc": "Ho9lYW_whyDesc",
  "whyGrid": "Ho9lYW_whyGrid",
  "whyIcon": "Ho9lYW_whyIcon",
  "whyItem": "Ho9lYW_whyItem",
  "whyList": "Ho9lYW_whyList",
  "whyPBody": "Ho9lYW_whyPBody",
  "whyPClosing": "Ho9lYW_whyPClosing",
  "whyPIntro": "Ho9lYW_whyPIntro",
  "whySubheading": "Ho9lYW_whySubheading",
  "whyTitle": "Ho9lYW_whyTitle",
});
